/* eslint-disable @typescript-eslint/no-unsafe-return */
import type { ZodSchema, z } from 'zod';
import { parseZodError } from './apiErrorLogger';

export const validateSchemaAsync =
  <S extends ZodSchema>(schema: S) =>
  async (data: Promise<z.input<S>>): Promise<z.infer<S>> => {
    const resolved = await data;
    const parsedResult = schema.safeParse(resolved);

    if (!parsedResult.success) {
      const parsedErrors = parsedResult.error ? parseZodError(parsedResult.error) : [];
      throw new Error(parsedErrors.join('\n'));

      // throw new Error(`API response validation failed: ${parsedErrors.join(', ')}`);
    }

    return parsedResult.data;
  };
